export default __webpack_public_path__ + "static/media/PlusIconWhite.b194c2f9.svg";